
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#F25022","d":"M1 1h9v9H1z"}}),_c('path',{attrs:{"fill":"#7FBA00","d":"M11 1h9v9h-9z"}}),_c('path',{attrs:{"fill":"#00A4EF","d":"M1 11h9v9H1z"}}),_c('path',{attrs:{"fill":"#FFB900","d":"M11 11h9v9h-9z"}})])
          )
        }
      }
    